import { render } from "./FooterApp.vue?vue&type=template&id=07940502&scoped=true"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"

import "./FooterApp.vue?vue&type=style&index=0&id=07940502&lang=scss&scoped=true"

import exportComponent from "/Users/spineup/Downloads/Safe_Sites_Modifs/SAFE_GROUP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07940502"]])

export default __exports__